import * as React from "react";
import { ArticleGW } from "./ArticleGW"
import { MakeNational } from "./BDKalkCore"

/* ArticleOrderGW represents an amount and a specific choise of an article, taking into concideration its selected supplier and type of package aswell, resulting in
 * an orderable and enlistable component within a selection set.  */ 
export class ArticleOrderGW {
    constructor() {
        this.m_amount = 0
        this.m_supplierName = ""
        this.m_supplierId = ""
        this.m_unit = ""
        this.m_unitId = ""
        this.m_nobbNr = 0
        this.m_packageUnits = 1
        this.m_orderingId = ""
        this.m_renderStage = 0
        this.m_renderFlags = 0
    }

    // Render method for display in a quick report order
    public Render() {
        if (this.GetAmount() == 0) {
            return <div></div>
        }

        const amount = this.GetAmount().toString() + " " + this.GetUnit()

        var varetext = ""
        var articleId = ""
        var text1 = ""
        var text2 = ""

        if (this.m_article != null) {
            varetext = this.m_article.GetDescription()
            articleId = this.m_article.GetIdentifier()
            text1 = this.m_article.GetDescription()
            text2 = this.m_article.GetDescription2()
        }

        var unitPriceString = "unknown"
        var article = this.GetArticle()

        if (article != null) {
            unitPriceString = article.GetUnitPriceString(this.m_renderStage, this.m_renderFlags, true, null)
        }

        var sum = this.GetSumString(this.m_renderStage, this.m_renderFlags & 7)

        return <div style={{ width: "calc(100% - 20px)", display: 'flex', flexDirection: 'row', marginLeft: '20px' }} >
            <div style={{ width: "8%", position: "relative", top: "6px" }}>{articleId}</div>

            <div style={{ width: "10%", position: "relative", top: "6px", textAlign: "right" }}>{MakeNational(this.trimValue(this.GetAmount()))}
            </div>

            <div style={{ width: "3%" }}>
            </div>

            <div style={{ width: "8%", position: "relative", top: "6px" }}>{this.GetUnitId()}</div>
            <div style={{ width: "8%", position: "relative", top: "6px", textAlign: "right" }}>{unitPriceString}</div>
            <div style={{ width: "10%", position: "relative", top: "6px", textAlign: "right" }}>{MakeNational(sum)}</div>

            <div style={{ width: "3%" }}>
            </div>

            <div style={{ width: "52%", display:"flex", flexDirection:"column" }}>
                <div style={{ position: "relative", top: "6px" }}>{text1}</div>
                <div style={{ position: "relative", top: "6px" }}>{text2}</div>
                <div style={{ height: "15px" }}></div> {/* bottom margin toward the next item */}
            </div>
        </div >
    }
    
    // Access : amount
    public SetAmount(amount: number) {
        this.m_amount = amount
    }

    // Access : amount
    public GetAmount() {
        return this.m_amount
    }

    // Access : supplierName
    public SetSupplierName(supplierName: string) {
        this.m_supplierName = supplierName
    }

    // Access : supplierName
    public GetSupplierName() {
        return this.m_supplierName
    }

    // Access : unitName
    public SetUnit(unitName: string) {
        this.m_unit = unitName
    }

    // Access : unit
    public GetUnit() {
        return this.m_unit
    }

    // Access : supplierId
    public SetSupplierId(supplierId: string) {
        this.m_supplierId = supplierId
    }

    // Access : supplierId
    public GetSupplierId() {
        return this.m_supplierId
    }

    // Access : m_unitId
    public SetUnitId(unitId: string) {
        this.m_unitId = unitId
    }

    // Access : m_unitId
    public GetUnitId() {
        return this.m_unitId
    }

    // Access : article
    public SetArticle(article: ArticleGW) {
        this.m_article = article
    }

    // Access : article
    public GetArticle() {
        return this.m_article
    }

    // Access : nobb
    public SetNobb(nobb: number) {
        this.m_nobbNr = nobb
    }

    // Access : nobb
    public GetNobb() {
        return this.m_nobbNr
    }

    // Access : orderingId
    public SetOrderingId(id: string) {
        this.m_orderingId = id
    }

    // Access : orderingId
    public GetOrderingId() {
        return this.m_orderingId
    }

    // GetSumString calculates the price of this article order
    public GetSumString(stage:number, flags:number) {
        const article = this.GetArticle();
        const price = article == null ? 0 : article.GetUnitPrice(stage, flags)
        var result = (this.GetAmount() * this.GetPackageUnits() * price).toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return result
    }

    // GetSum calculates the price of this article order
    public GetSum(stage: number, flags: number) {
        const article = this.GetArticle();
        const price = article == null ? 0 : article.GetUnitPrice(stage, flags)
        return  (this.GetAmount() * this.GetPackageUnits() * price)
    }

    // trimValue returns a given value as a string, and trims it to 2 decimals
    public trimValue(value: number) {
        var result = value.toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return result
    }

    // Access : packageUnits
    public GetPackageUnits() {
        return this.m_packageUnits
    }

    // Access : packageUnits
    public SetPackageUnits(amount: number) {
        this.m_packageUnits = amount
    }

    // Access : priceBook
    public GetPriceBook() {
        return this.m_priceBook
    }

    // Access : priceBook
    public SetPriceBook(index: number) {
        this.m_priceBook = index
    }

    // Access : rendering states
    public SetRenderingMode(stage: number, flags: number) {
        this.m_renderStage = stage
        this.m_renderFlags = flags
    }

    // Member variables
    private m_priceBook: number
    private m_amount: number
    private m_supplierName: string
    private m_supplierId: string
    private m_unit: string
    private m_unitId: string
    private m_article?: ArticleGW
    private m_nobbNr: number
    private m_packageUnits: number
    private m_orderingId: string
    private m_renderStage: number
    private m_renderFlags: number
}



// WEBPACK FOOTER //
// ./client/view/ArticleOrderGW.tsx